import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertRuleApi } from '../../../apis/AlertRuleApi/AlertRuleApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IAlertRuleConfiguration, ICreateAlertRuleConfigurationRequest } from '../Alert';

export function useCreateAlertRuleConfiguration() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IAlertRuleConfiguration, AppMedError, { alertRuleId: number; request: ICreateAlertRuleConfigurationRequest }>({
        mutationKey: [QueryKeys.alertRuleConfigurations, 'create'],
        mutationFn: async ({ alertRuleId, request }) => {
            return await AlertRuleApi.createAlertRuleConfiguration(alertRuleId, request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertRuleConfigurations] });
            notifications.show({
                title: t('notification.success'),
                message: t('alertRule.notifications.configurationCreated'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
